import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';
import List from '../PageBuilder/List';
import TextInput from '../PageBuilder/forms/TextInput';
import TextArea from '../PageBuilder/forms/TextArea';

const NotesWidget = ({ list, containerSettings }) => (
  <Container className="notes" settings={containerSettings}>
    <div className="container">
      <ol>
        {list.map((item, idx) =>
          <li key={idx}><strong id={item.anchor}>{item.term}:</strong> {item.definition} <a href="javascript:window.history.go(-1);">↩︎</a></li>)}
      </ol>
    </div>
  </Container>
);

NotesWidget.title = 'Notes';
NotesWidget.category = 'Content';

NotesWidget.propTypes = {
  list: PropTypes.array.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

NotesWidget.defaults = {
  list: [
    { id: 1, anchor: '', term: 'term', definition: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt, adipisci.' },
    { id: 2, anchor: '', term: 'term', definition: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam, id.' },
    { id: 3, anchor: '', term: 'term', definition: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore, reprehenderit!' },
  ],
};

const Note = ({ settings, onChangeItem }) => (
  <div>
    <TextInput
      label="Anchor"
      onChange={value => onChangeItem('anchor', value)}
      value={settings.anchor}
    />

    <TextInput
      label="Term"
      onChange={value => onChangeItem('term', value)}
      value={settings.term}
    />

    <TextArea
      label="Definition"
      onChange={value => onChangeItem('definition', value)}
      value={settings.definition}
    />
  </div>
);

Note.propTypes = {
  settings: PropTypes.object.isRequired,
  onChangeItem: PropTypes.func.isRequired,
};

NotesWidget.adminFields = (items, onChangeList) => (
  <List
    listItem={(settings, onChangeItem) =>
      <Note settings={settings} onChangeItem={onChangeItem} />}
    onChangeList={onChangeList}
    items={items}
  />
);

export default NotesWidget;
